import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material';
import { NotificationLevel } from '../../services/api/notifications/notifications.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  type: NotificationLevel;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private _snackRef: MatSnackBarRef<NotificationComponent>
  ) {
  }

  ngOnInit() {
    this.type = this.data.snackType;
  }

  close() {
    this._snackRef.dismiss();
  }
}
